function validate(rootElement: HTMLElement): void {
  const radioButtons = rootElement.querySelectorAll('input[type=radio]');

  radioButtons.forEach((radio) => {
    if (!(radio instanceof HTMLInputElement)) {
      return;
    }

    if (radio.checkValidity()) {
      radio
        .closest('.product-form__item-radio')
        ?.classList.remove('product-form__item-radio--invalid');
      return;
    }

    radio
      .closest('.product-form__item-radio')
      ?.classList.add('product-form__item-radio--invalid');
  });
}

export function initVariantOptionsValidation(): void {
  const productForm = document.querySelector('.product-form');
  if (productForm instanceof HTMLFormElement) {
    productForm.setAttribute('novalidate', 'true');
    productForm.addEventListener('submit', (e) => {
      if (!productForm.checkValidity()) {
        e.preventDefault();
      }

      validate(productForm);
    });

    const buyNowButton = document.getElementById('buy-now-button');
    buyNowButton &&
      buyNowButton.addEventListener('click', (e) => {
        if (!productForm.checkValidity()) {
          e.preventDefault();
        }

        validate(productForm);
      });

    const radioButtons = productForm.querySelectorAll('.radio-box');
    radioButtons.forEach((radioBox) => {
      const radio = radioBox.querySelector('input[type=radio]');
      if (
        !(radio instanceof HTMLInputElement) ||
        !(radioBox instanceof HTMLElement)
      ) {
        return;
      }

      radio.addEventListener('change', () => {
        validate(radioBox);
      });
    });
  }
}
